<template>
  <div>
    <l-bg />
    <l-stripes-horizontal scrollMobile :count="42">
      <div :class="$style.cols">
        <l-col
          v-for="(col, index) in cols"
          :key="index"
          :coef="42"
          disabled
          :offline="col.offline"
          :right="col.right"
          :highlight="col.highlight"
          v-model="col.value"
        >
          <template #num v-if="col.highlight">
            <l-dash-input v-model="col.input" @input="() => handleInput(index)" :disabled="stage !== 2 || col.disabled" />
          </template>
        </l-col>
      </div>
    </l-stripes-horizontal>
    <l-popupMessage
      :items="messages"
      :task="task"
      @click="nextStage"
    />
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'

import { pushPopup } from '@/utils/pushPopup'

import { ideal } from './data'

import { arr1, arr2, task } from './arrs'

export default {
  name: 'step3',
  setup(props, { emit }) {
    const stage = ref(0)
    const messages = ref([])

    const cols = ref(ideal.map((c, i) => ({
      ...c,
      right: false,
      input: '',
      offline: i < 8 || i > 15,
      highlight: i >= 8 && i <= 15,
    })))

    const nextStage = () => {
      messages.value = []

      if (stage.value === 0) {
        pushPopup(arr1, messages.value)
      }

      if (stage.value === 3) {
        cols.value = cols.value.map(c => ({ ...c, highlight: false, offline: true }))
        pushPopup(arr2, messages.value)
      }

      if (stage.value === 4) {
        emit('nextStep', 4)
      }

      stage.value += 1
    }

    nextStage()

    const check = () => {
      const highlight = cols.value.filter(c => c.highlight)
      return highlight.every(c => Math.floor(c.value * 42) === Number(c.input))
    }

    const handleInput = (index) => {
      const col = cols.value[index]

      if (col.input.length < 2) return

      if (Number(col.input) !== Math.floor(cols.value[index].value * 42)) {
        setTimeout(() => { col.input = '' }, 100)
      } else {
        col.right = true
        cols.value[index].disabled = true
      }

      setTimeout(() => {
        if (check()) nextStage()
      }, 200)
    }

    return {
      messages,
      stage,
      cols,
      task,

      ideal,

      nextStage,
      handleInput,
    }
  },
}
</script>
<style lang="scss" module>
.cols {
  position: absolute;
  left: 11rem;
  right: 11rem;
  bottom: 2px;
  top: 2px;
  display: flex;
  align-items: flex-end;
  pointer-events: none;
}
</style>
